import React from 'react'
import { Card, CardHeader, Typography, Box } from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'
import { selectGroupedTeamMemberReport } from '../../../../redux/reports/event/invitedTeamMemberPerEvent/selector'
import { useSelector } from 'react-redux'
import { transformTeamDataToBarChart } from '../../../../utils/chartUtils'

const EventParticipantChart: React.FC = () => {
  const teamData = useSelector(selectGroupedTeamMemberReport)

  const chartData = transformTeamDataToBarChart(teamData.data || {}, {
    series: ['registered', 'unregistered'],
    sortBy: 'label',
    sortOrder: 'desc',
  })

  const chartSetting = {
    xAxis: [
      {
        label: 'No. of Participants',
        tickMinStep: 1,
      },
    ],
    height: 550, // Increased height to show all teams
  }

  return (
    <Card elevation={0}>
      <CardHeader
        title={
          <Typography
            sx={{
              fontSize: fontSizes.size16,
              fontWeight: fontWeights[700],
            }}
          >
            Event Participants Report
          </Typography>
        }
      />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BarChart
          yAxis={[
            {
              dataKey: 'label',
              width: 200,
            },
          ]}
          series={Object.keys(chartData[0] || {})
            .filter((key) => key !== 'label')
            .map((key, index) => ({
              dataKey: key,
              label: key.charAt(0).toUpperCase() + key.slice(1),
              color: index === 0 ? '#008552' : '#d53369',
              stack: 'stacked',
            }))}
          layout='horizontal'
          borderRadius={4}
          dataset={chartData}
          {...chartSetting}
        />
      </Box>
    </Card>
  )
}

export default EventParticipantChart
